import React, { useEffect, useState } from "react";

/**
 * OfflineBanner — fixed banner at the top of the app that shows when
 * navigator.onLine flips to false. Auto-dismisses on reconnect.
 */
export default function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    const onUp = () => setOnline(true);
    const onDown = () => setOnline(false);
    window.addEventListener("online", onUp);
    window.addEventListener("offline", onDown);
    return () => {
      window.removeEventListener("online", onUp);
      window.removeEventListener("offline", onDown);
    };
  }, []);

  if (online) return null;

  return (
    <div
      role="alert"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)",
        color: "#FFFFFF",
        padding: "10px 18px",
        fontSize: 13,
        fontWeight: 600,
        textAlign: "center",
        boxShadow: "0 4px 14px rgba(185, 28, 28, 0.35)",
        letterSpacing: "0.01em",
        animation: "vellaOfflineSlide 0.25s ease-out",
      }}
    >
      <style>{`
        @keyframes vellaOfflineSlide {
          from { transform: translateY(-100%); opacity: 0; }
          to   { transform: translateY(0); opacity: 1; }
        }
      `}</style>
      <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <line x1="1" y1="1" x2="23" y2="23" />
          <path d="M16.72 11.06A10.94 10.94 0 0119 12.55" />
          <path d="M5 12.55a10.94 10.94 0 015.17-2.39" />
          <path d="M10.71 5.05A16 16 0 0122.58 9" />
          <path d="M1.42 9a15.91 15.91 0 014.7-2.88" />
          <path d="M8.53 16.11a6 6 0 016.95 0" />
          <line x1="12" y1="20" x2="12.01" y2="20" />
        </svg>
        You're offline. Vella will reconnect when you're back.
      </span>
    </div>
  );
}
